import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

export function WorkingWithBreederButtonContent({ title, subtitle, iconName }) {
  return (
    <>
      <div>
        <p className="font-16 md:font-18 fw-medium">{title}</p>
        <p className="font-14 md:font-18 secondary mt1">{subtitle}</p>
      </div>
      <div className="br-100 ba b--default ph2 pv2">
        <Icon
          className="secondary"
          name={iconName}
          height="16px"
          width="16px"
        />
      </div>
    </>
  );
}

WorkingWithBreederButtonContent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  iconName: PropTypes.string
};

WorkingWithBreederButtonContent.defaultProps = {
  iconName: 'fetch-plus'
};

export default function WorkingWithBreederButton({
  className,
  title,
  subtitle,
  iconName,
  onClick
}) {
  return (
    <button
      type="button"
      className={classnames(
        'WorkingWithBreederButton w-100 ph4 pv4 ba b--default br12 inline-flex gap-8 items-center justify-between lh-body',
        className
      )}
      onClick={onClick}
    >
      <WorkingWithBreederButtonContent
        title={title}
        subtitle={subtitle}
        iconName={iconName}
      />
    </button>
  );
}

WorkingWithBreederButton.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

WorkingWithBreederButton.defaultProps = {
  className: null,
  iconName: 'fetch-plus'
};
